import { useEffect, useRef } from 'react';
import { useMediaQuery } from '@mui/material';
import { useSidebarState, useStore } from 'react-admin';
import { NARROW_LAYOUT_QUERY, sidebarOnWidthChange } from './layoutWidth';

/**
 * Czy okno jest wąskie (poniżej 1280 px, `layoutWidth.ts`). Bez
 * `matchMedia` (Jest) — `false`, czyli układ jak dotąd.
 */
export function useNarrowLayout(): boolean {
  return useMediaQuery(NARROW_LAYOUT_QUERY, { noSsr: true });
}

/** Klucz magazynu react-admina: menu zwinęło wąskie okno, nie użytkownik. */
export const SIDEBAR_AUTO_COLLAPSED_KEY = 'sidebar.autoCollapsed';

/**
 * Menu boczne zwija się do ikon poniżej 1280 px i wraca po poszerzeniu okna
 * (29.10.2026, decyzja Bartka: „1024 px — zrób tak, żeby było dobrze
 * i czytelnie”) — treść zyskuje ok. 130 px. Rozwinąć można przyciskiem ☰
 * w pasku; reguła reaguje tylko na zmianę szerokości (`sidebarOnWidthChange`).
 */
export function useAutoCollapseSidebar(): void {
  const narrow = useNarrowLayout();
  const [open, setOpen] = useSidebarState();
  const [autoCollapsed, setAutoCollapsed] = useStore<boolean>(SIDEBAR_AUTO_COLLAPSED_KEY, false);
  const seen = useRef<boolean | null>(null);
  useEffect(() => {
    if (seen.current === narrow) return;
    seen.current = narrow;
    const next = sidebarOnWidthChange(narrow, { open, autoCollapsed });
    if (next.open !== open) setOpen(next.open);
    if (next.autoCollapsed !== autoCollapsed) setAutoCollapsed(next.autoCollapsed);
  }, [narrow, open, autoCollapsed, setOpen, setAutoCollapsed]);
}
